"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["className", "classes"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  return {
    /* Styles applied to the root element. */
    root: {
      padding: theme.busbud.spacing(2, 2.5),
      '&:not(:first-child):last-child': {
        paddingBottom: theme.busbud.spacing(2.5)
      },
      [theme.busbud.breakpoints.up('md')]: {
        padding: theme.busbud.spacing(3, 3.5),
        '&:not(:first-child):last-child': {
          paddingBottom: theme.busbud.spacing(3.5)
        }
      }
    }
  };
});
/**
 * **❗️ DEPRECATED**: Use the new `Card.Body` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/data-display-card-card-body):
 *
 * ```tsx
 * import { Card } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/data-display-card-card-body)
 *
 * @deprecated
 */
const CardContent = /*#__PURE__*/_react.default.forwardRef(function CardContent(props, ref) {
  const {
      className,
      classes: classesOverrides
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, className),
    ref: ref
  }, other));
});
var _default = exports.default = CardContent;